// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { signalBars16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-signal-bars': IconSignalBars;
    }
}

/**
 * The icon component for the 'signalBars' icon
 */
export class IconSignalBars extends IconSvg {
    public constructor() {
        super(signalBars16X16);
    }
}

registerIconSvg('icon-signal-bars', IconSignalBars);
export const iconSignalBarsTag = 'nimble-icon-signal-bars';
